import styled from 'styled-components'
import { Col } from 'reactstrap';

export const SideBackgroundImageContainer = styled.div.attrs({
})`          
    background: ${props => props.theme.palette.primary.main}; 
    min-height:100vh;
    display: flex;
    align-items: center;
    justify-content: center;

    @media(max-width: 767px){ 
        position: relative;
        min-height:initial; 
        width: 100%;
    }
`;
export const SideBackgroundImage = styled.div.attrs({
})`          
`;

export const FormContent = styled.div.attrs({
})`           
    min-height: ${p => p.noHeader ? '100vh' : 'calc(100vh - 112px)'};
    display: flex;
    align-items: ${p => p.login ? 'center' : 'flex-start'};
    justify-content: center;
    position: relative;
    padding: 48px clamp(20px, 5vw, 64px) 64px;
    background:
        radial-gradient(circle at top left, ${p => p.theme.palette.colors.shellGradientStart} 0%, ${p => p.theme.palette.colors.shellGradientEnd} 46%),
        radial-gradient(circle at bottom right, ${p => p.theme.palette.colors.shellGlow} 0%, ${p => p.theme.palette.colors.backgroundTransparent} 42%);
    @media(max-width: 767px){
        padding: 20px 16px 32px;
    }
`;
export const AppLogo = styled.img.attrs({
    src: '/logo1024.png',
    width: 120
})`           
`;

export const StyledCol = styled(Col).attrs({})`
${p => p.lightBlue ? `background: linear-gradient(180deg, ${p.theme.palette.colors.surfaceElevatedStrong} 0%, ${p.theme.palette.colors.background} 100%);` : ``};
    @media(max-width: 991px) {
        ${p => p.full ? `
            width: 100%;
            flex: 0 0 100%;
        `: `display: none;`};
    }
`;



export const Content = styled.div.attrs({
})`           
    overflow:hidden;
    min-height: 100vh;
    background:
        radial-gradient(circle at top left, ${props => props.theme.palette.colors.shellGradientStart} 0%, ${props => props.theme.palette.colors.shellGradientEnd} 32%),
        radial-gradient(circle at bottom right, ${props => props.theme.palette.colors.shellGlow} 0%, ${props => props.theme.palette.colors.backgroundTransparent} 36%),
        ${props => props.theme.palette.colors.background};
`;

export const Touch = styled.div.attrs({
})`           
    cursor: pointer;
`;

export const HeaderContainer = styled.div.attrs({
})`           
    padding: 26px clamp(18px, 5vw, 36px);
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 112px;
    background:
        linear-gradient(180deg, ${props => props.theme.palette.colors.backgroundStrong} 0%, ${props => props.theme.palette.colors.backgroundSoft} 100%);
    border-bottom: 1px solid ${props => props.theme.palette.colors.borderSoft};
    box-shadow: 0 16px 42px ${props => props.theme.palette.colors.shadowStrong};
    width: 100%;
`;

export const AcceleratorBrand = styled.button.attrs({ type: 'button' })`
    display: inline-flex;
    align-items: baseline;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
    padding: 8px 12px;
    border: 0;
    background: transparent;
    color: ${props => props.theme.palette.colors.text};
    cursor: pointer;
    line-height: 1.05;
    text-align: center;

    &:focus-visible {
        outline: 2px solid ${props => props.theme.palette.blue.main};
        outline-offset: 4px;
        border-radius: 8px;
    }
`;

export const AcceleratorBrandName = styled.span`
    font-family: Gilroy;
    font-size: clamp(28px, 4vw, 42px);
    font-weight: 700;
`;

export const AcceleratorBrandProgram = styled.span`
    font-family: Gilroy-Light;
    font-size: clamp(26px, 3.8vw, 40px);
    font-weight: 300;
`;

export const HeaderActions = styled.div.attrs({})`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const ThemeToggle = styled.button.attrs({
    type: 'button'
})`
    width: 46px;
    height: 46px;
    border-radius: 999px;
    border: 1px solid ${p => p.theme.palette.colors.borderSoft};
    background: ${p => p.theme.palette.colors.buttonGhost};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: transform 0.22s ease, background 0.22s ease, box-shadow 0.22s ease;
    box-shadow: 0 10px 28px ${p => p.theme.palette.colors.shadowStrong};

    &:hover {
        transform: translateY(-1px);
        background: ${p => p.theme.palette.colors.badgeMuted};
    }
`;
